import { apiGet } from '@/lib/http/client';

import type { SalesforceStatusResponse } from '../types';

export async function getSalesforceStatus(
  orgId: number | string
): Promise<SalesforceStatusResponse> {
  return apiGet<SalesforceStatusResponse>(
    `/api/orgs/${orgId}/salesforce/status/`
  );
}
